import { render, staticRenderFns } from "./WindowSendEmail.vue?vue&type=template&id=38e3394c&"
import script from "./WindowSendEmail.vue?vue&type=script&lang=js&"
export * from "./WindowSendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports